export default __webpack_public_path__ + "static/media/fp7.31ea1898.png";